export default {"src":"/_next/static/media/lock.5a9d6a2d.svg","height":119,"width":104,"blurWidth":0,"blurHeight":0};